import React from "react";
import { Box } from "@mui/material";
import {
  ExecutorVerificationStep,
  ExecutorVerificationStepDetails,
  ExecutorVerificationStatus,
} from "models/ExecutorVerification";
import { VerificationStep } from "./VerificationStep";
import { Loading } from "views/shared/Loading";

interface IProps {
  steps: ExecutorVerificationStep[] | null;
  statusesMap: { [key: number]: ExecutorVerificationStatus } | null;
  stepDetailsMap: { [key: number]: ExecutorVerificationStepDetails } | null;
  onButtonClick?: (title: string, verificationStepId: number) => void;
}

export const VerificationSteps = (props: IProps): JSX.Element => {
  if (!props.steps) {
    return <Loading />;
  }

  return (
    <Box
      style={{
        margin: "1rem",
        padding: "0.5rem",
        backgroundColor: "white",
        width:"100%",
      }}
    >
      {props.steps.map((step, index) => (
        <Box key={"verificationstepbox" + index}>
          <VerificationStep
            key={"verificationstep" + index}
            step={step}
            statusesMap={props.statusesMap || {}}
            stepDetails={
              props.stepDetailsMap
                ? props.stepDetailsMap[step.verificationStepId || -1]
                : null
            }
            onButtonClick={() => {
              if (
                props &&
                props.stepDetailsMap &&
                step.verificationStepId &&
                props.stepDetailsMap[step.verificationStepId] &&
                props.onButtonClick
              ) {
                props.onButtonClick(
                  props.stepDetailsMap[step.verificationStepId].name,
                  step.verificationStepId,
                );
              }
            }}
          />
          {index !== (props.steps?.length || 0) - 1 && <hr />}
        </Box>
      ))}
    </Box>
  );
};
